module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-5 pt-5 pr-5",
          staticStyle: {
            "max-width": "215px"
          },
          attrs: {
            "placeholder": "From",
            "append-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          on: {
            "click:clear": function($event) {
              _vm.dateFilter.startDate = null
            }
          },
          model: {
            value: (_vm.dateFilter.startDate),
            callback: function($$v) {
              _vm.$set(_vm.dateFilter, "startDate", $$v)
            },
            expression: "dateFilter.startDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.startCal),
      callback: function($$v) {
        _vm.startCal = $$v
      },
      expression: "startCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.startCal = false
      }
    },
    model: {
      value: (_vm.dateFilter.startDate),
      callback: function($$v) {
        _vm.$set(_vm.dateFilter, "startDate", $$v)
      },
      expression: "dateFilter.startDate"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-5 pt-5 pr-5",
          staticStyle: {
            "max-width": "215px"
          },
          attrs: {
            "placeholder": "To",
            "append-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          on: {
            "click:clear": function($event) {
              _vm.dateFilter.endDate = null
            }
          },
          model: {
            value: (_vm.dateFilter.endDate),
            callback: function($$v) {
              _vm.$set(_vm.dateFilter, "endDate", $$v)
            },
            expression: "dateFilter.endDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.endCal),
      callback: function($$v) {
        _vm.endCal = $$v
      },
      expression: "endCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month"
    },
    on: {
      "input": function($event) {
        _vm.endCal = false
      }
    },
    model: {
      value: (_vm.dateFilter.endDate),
      callback: function($$v) {
        _vm.$set(_vm.dateFilter, "endDate", $$v)
      },
      expression: "dateFilter.endDate"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "btn-search",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-chevron",
    attrs: {
      "text": "",
      "disabled": _vm.disableLeftArrow
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeMonth', 'previous')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v("mdi-chevron-left-circle")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-chevron",
    attrs: {
      "text": "",
      "disabled": _vm.disableRightArrow
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeMonth', 'next')
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v("mdi-chevron-right-circle")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "table-calendar elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "item.poc",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n        " + _vm._s(item.poc) + "\n      ")])]
      }
    }, {
      key: "item.bfs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-start"
        }, [(item.bfs) ? _c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "to": '/client/brand-fact-sheet?id=' + item.bfs,
            "target": '_blank'
          }
        }, [_vm._v("\n          View BFS\n        ")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])]
      }
    }, _vm._l((_vm.calendarMonths), function(month) {
      return {
        key: ("item." + month),
        fn: function(ref) {
          var item = ref.item;

          return [(item[month] || item[month] === 0) ? _c('td', {
            staticClass: "text-center",
            style: (("background-color:" + (item.bgColor) + ";opacity:0.8"))
          }, [_c('div', {
            staticClass: "text-inside"
          }, [_vm._v(_vm._s(item[month]))])]) : _c('td', {
            staticClass: "text-center"
          }, [_vm._v("\n        " + _vm._s(item[month]) + "\n      ")])]
        }
      }
    })], null, true)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f736194"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/AOKReport/CalendarTable.vue
// module id = 2064
// module chunks = 0